<template>
  <q-layout-header class="no-shadow text-colorTransport" v-if="this.$q.platform.is.desktop">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-5 logo">
        <a href="/">
          <b><span class="orange-logo">multi</span><span class="blue-logo">cargo</span></b>
        </a>
      </div>
    </div>
    <!-- <profile-modal :open="modal" @closeModal="modal = false" /> -->
  </q-layout-header>
  <q-layout-header class="no-shadow" v-else>
  <div class="row">
    <div class="col-4 logo">
        <b><span class="orange-logo">multi</span><span class="blue-logo">cargo</span></b>
      </div>
    <div class="col-1 offset-6">
      <q-btn flat color="orange" size="1.4rem" icon="reorder" @click="opened = true"/>
    </div>
  </div>
  </q-layout-header>
</template>

<script>
import axios from '@/axios'
export default {
  props: {
    isLogin: Boolean,
    isHelp: Boolean,
    isFreight: Boolean,
    isWhatIsM: Boolean,
    isOffer: Boolean,
    isHome: Boolean,
    colorType: String
  },
  data () {
    return {
      opened: false,
      userLogged: false,
      admin: false
    }
  },
  created () {
    if (window.localStorage.getItem('userToken') !== null && window.localStorage.getItem('userToken') !== '') {
      this.$store.dispatch('getUserInfo')
      this.userLogged = true
    }
    this.getRole()
  },
  computed: {
    userName () {
      return this.$store.getters.userName
    }
  },
  methods: {
    getRole () {
      axios.get('/platform/user/roles')
        .then(res => {
          res.data.forEach(element => {
            if (element.authority === 'ROLE_ADMIN') {
              this.admin = true
            }
          })
        })
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'Nunito';
  src: url('../assets/fonts/Nunito-Regular.ttf');
}
#main{
  overflow: hidden;
  font-family: 'Nunito', sans-serif !important;
}
.orange-logo{
  color: #F79520;
}
.blue-logo{
  color: #326394;
}
.layout-modal{
  background: linear-gradient(-308deg, #326394 -50%, #18283a 70%);
  color: #f4f4f4;
}
.layout-modal-home{
  background: linear-gradient(-308deg, #878484 -50%, #111111 70%);
  color: #f4f4f4;
}
.layout-freight{
  background: linear-gradient(286deg, rgba(10, 43, 28, 0.9) 37%, rgba(16, 65, 43, 0.9) 80%);
  color: #f4f4f4;
}
.logo {
  font-family: 'Nunito', sans-serif !important;
  font-size: 3rem;
  padding-left: 3%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.fullcenter{
  padding: 1.5% 2%;
  display: flex;
  font-size: 80%;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  transition: transform .3s;
  cursor: pointer;
}
.fullcenterhome{
  padding: 1.5% 2%;
  display: flex;
  font-size: 80%;
  color: white;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  transition: transform .3s;
  cursor: pointer;
}
.fullcenterhome:hover{
  background: #111111;
  color: #f4f4f4;
  font-size: 75%;
  transform: scale(1.05);
  font-weight: 600;
}
.freight{
  padding: 1.5% 2%;
  display: flex;
  font-size: 80%;
  color: white;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  transition: transform .3s;
  cursor: pointer;
}
.beDriver{
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-items: center;
  padding-right: 10px;
}
.freight:hover{
  background: rgba(21, 88, 59);
  color: #f4f4f4 !important;
  font-size: 75%;
  transform: scale(1.05);
  font-weight: 600;
}
.text-colorTransport{
  color: #292929;
}
.fullcenter:hover{
  background: #18283a;
  color: #f4f4f4;
  font-size: 75%;
  transform: scale(1.05);
  font-weight: 600;
}
.item{
  border-bottom: 1px solid #f4f4f4;
  margin-left: 5%;
  margin-right: 5%;
}
.itemSelected{
  border: 1px solid #326394;
  margin-left: 0;
  margin-right: 0;
}
.selected{
  background-color: #326394;
  color: #f4f4f4;
  font-weight: 600;
}
.button-header{
  width: 100%;
  padding-left:0;
  padding-right:0;
}
a{
  text-decoration: none;
}
@media only screen and (max-width: 640px) {
  .logo {
    font-size: 1.5rem;
    padding-left: 4%;
  }
}
</style>
